// extracted by mini-css-extract-plugin
export var close = "style-module--close--h5OkI";
export var icon = "style-module--icon--BQCk0";
export var imglyTypoButton = "style-module--imgly--typo-button--aajl+";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--PO6Ua";
export var imglyTypoH1 = "style-module--imgly--typo-h1--mBa9T";
export var imglyTypoH2 = "style-module--imgly--typo-h2--0orXR";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--TwS0E";
export var imglyTypoH3 = "style-module--imgly--typo-h3--SaVBb";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--8Zler";
export var imglyTypoH4 = "style-module--imgly--typo-h4--ji5Tm";
export var imglyTypoH5 = "style-module--imgly--typo-h5--2KFL6";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--XYPCH";
export var imglyTypoIcon = "style-module--imgly--typo-icon--6rC6v";
export var imglyTypoLink = "style-module--imgly--typo-link--6mzq7";
export var imglyTypoOverline = "style-module--imgly--typo-overline--1EJG-";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--NFRxq";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--0Oh4Q";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--Yz4FQ";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--Fh0KG";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--U7gdt";
export var imglyTypoSubline = "style-module--imgly--typo-subline--MHnzp";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--X+NOn";
export var link = "style-module--link--B1voc";
export var naviLabelIsLarge = "style-module--navi-label-is-large--zAGJh";
export var naviLabelIsSmall = "style-module--navi-label-is-small--LfvUJ";
export var root = "style-module--root--B3AQM";
export var text = "style-module--text--7YxhU";